import { Box, Stack, SxProps } from "@mui/material";
import { FC, ReactNode } from "react";
import { cacheService } from "../../Core/Api/services";
import { ActivityKind } from "../../Core/Api/Types/activity-kind";
import { ActivityType } from "../../Core/Api/Types/activity-type";
import { DbObjectCreateOrUpdateInfos } from "../../Core/Api/Types/db-object-create-or-update-infos";
import { ObjectLayer } from "../../Core/Api/Types/object-layer";
import { ObjectType } from "../../Core/Api/Types/object-type";
import ActivityCommentFeed from "./AcitivityDetails/activity-comment-feed";
import ActivityDetails from "./AcitivityDetails/activity-details";
import { ActivityError } from "./AcitivityDetails/activity-error";
import ActivityField from "./AcitivityDetails/activity-field";
import ActivityContext from "./ActivityContext/activity-context";
import ActivityHeading from "./ActivityHeading/activity-heading";

export interface ActivityMappedData {
  expendElement?: ReactNode;
  id: number;
  replyId: number | null;
  // user infos
  userName: string;
  userId: number | null;
  userInitials: string;
  // activity infos
  activityKind: ActivityKind;
  activityType: ActivityType;
  activityDate?: Date;
  activityVariant: ActivityVariant;
  error: boolean;
  read: boolean;
  activityDetails: string;
  // heading
  headingLabel: string;
  headingAction?: string;
  headingLinkToResource?: string;
  // context
  contextAssetType?: ObjectType;
  contextAssetLayer?: ObjectLayer;
  contextTitle: string;
  contextSubtitle?: string;
  contextLabel?: string;
  contextResId: number;
  replies: ActivityMappedData[] | null;
  solved: DbObjectCreateOrUpdateInfos | null;
}
export type ActivityVariant = "success" | "warning" | "error" | "info" | "primary" | "secondary";

export interface ActivityProps extends ActivityMappedData {
  sx?: SxProps;
  handleCommentSend?: (text: string, mainActivityId: number) => void;
}

const Activity: FC<ActivityProps> = (props) => {
  const myUserId = cacheService.GetUserInfo()!.id;

  return (
    <Box>
      {props.expendElement ? (
        <Stack spacing={1.5} direction="row" justifyContent="space-between">
          <ActivityHeading
            variant={props.activityVariant}
            label={props.headingLabel}
            action={props.headingAction}
            userInitials={props.userInitials}
            userName={props.userName}
            date={props.activityDate}
            isRead={props.read}
            linkToResource={props.headingLinkToResource}
            userId={props.userId}
          />
          {props.expendElement}
        </Stack>
      ) : (
        <ActivityHeading
          variant={props.activityVariant}
          label={props.headingLabel}
          action={props.headingAction}
          userInitials={props.userInitials}
          userName={props.userName}
          date={props.activityDate}
          isRead={props.read}
          linkToResource={props.headingLinkToResource}
          userId={props.userId}
        />
      )}

      <ActivityDetails>
        {props.activityKind === ActivityKind.OrderItem || props.activityKind === ActivityKind.Asset ? (
          <ActivityContext
            title={props.contextTitle}
            assetType={props.contextAssetType}
            assetLayer={props.contextAssetLayer}
            activityKind={props.activityKind}
            detail={props.activityDetails}
            label={props.contextLabel}
            subtitle={props.contextSubtitle}
            resId={props.contextResId}
          />
        ) : (
          !props.error && <ActivityField>{props.activityDetails}</ActivityField>
        )}

        {props.error && props.activityDetails && <ActivityError label="">{props.activityDetails}</ActivityError>}
        {props.handleCommentSend && (
          <ActivityCommentFeed
            parentActivityId={props.id}
            activities={props.replies ?? []}
            myUserId={myUserId}
            handleCommentSend={props.handleCommentSend}
          />
        )}
      </ActivityDetails>
    </Box>
  );
};

export default Activity;
